import clsx from "clsx";

interface HairlineCardBorderProps {
  roundedClassName?: string;
}

/**
 * HairlineCardBorder
 *
 * A subtle border overlay for cards, providing a consistent hairline border
 * appearance across card components. Uses an absolute positioned ring to avoid
 * affecting the card's layout or interactive elements.
 */
export function HairlineCardBorder({ roundedClassName = "tw-rounded-2xl" }: HairlineCardBorderProps) {
  return (
    <div
      className={clsx(
        "tw-absolute tw-pointer-events-none tw-inset-0 tw-ring-0.5 tw-ring-black/7.5 tw-ring-inset tw-z-30",
        roundedClassName,
      )}
    />
  );
}
